import { redirect } from 'react-router';
import { api } from '@/lib/api';

export interface UserProfile {
  id: number;
  username: string;
  role: string;
}

export function fetchMe(): Promise<UserProfile> {
  return api.get<UserProfile>('/api/auth/me');
}

/** RR8 data-mode loader for protected routes. */
export async function requireAuth(): Promise<UserProfile | Response> {
  try {
    return await fetchMe();
  } catch {
    return redirect('/login');
  }
}
